/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Directory_Evidence_CheckedInputs */

const en_directory_evidence_checked = /** @type {(inputs: Directory_Evidence_CheckedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked ${i?.date}`)
};

const zh_directory_evidence_checked = /** @type {(inputs: Directory_Evidence_CheckedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`核验于 ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Checked {date}" |
*
* @param {Directory_Evidence_CheckedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_evidence_checked = /** @type {((inputs: Directory_Evidence_CheckedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Evidence_CheckedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_evidence_checked(inputs)
	return zh_directory_evidence_checked(inputs)
});
export { directory_evidence_checked as "directory.evidence.checked" }